import { useQuery } from '@tanstack/react-query';
import { useAdminUserSession } from '../../../models/hooks/adminStateHooks';
import { ChargifyCredentials } from '../../../admin/components/tools/PricingWizard/types';

export const CHARGIFY_CREDENTIALS_QUERY_KEY = 'pricebook/chargify-credentials';

export function useChargifyCredentialsQuery({ enabled = true }: { enabled?: boolean } = {}) {
	const userSession = useAdminUserSession();
	return useQuery({
		queryKey: [CHARGIFY_CREDENTIALS_QUERY_KEY],
		queryFn: () =>
			userSession.webServiceHelper.callAsync<ChargifyCredentials>('admin/BillingUtilities/ChargifyJSSettings', 'GET'),
		enabled,
		staleTime: 30 * 60 * 1000, // 30 minutes - credentials don't change often
	});
}
